export { Api } from './api/api';
export { Items } from '../mocks/providers/items';
export { Settings } from './settings/settings';
export { WeatherProvider } from './weather/weather';
export { User } from './user/user';
export { Constants } from './constants';
export { SocketService } from './socket.service';
export { OfflineProvider } from './offline/offline';
export { UnknowFailureProvider } from './unknow-failure/unknow-failure';



// WEBPACK FOOTER //
// ./src/providers/index.ts